document.addEventListener('DOMContentLoaded', function() {
    const productMediaElement = document.querySelector('.product-preview__media');
    
    if (productMediaElement && typeof Swiper != 'undefined') {
        new Swiper(productMediaElement, {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 15,
            navigation: {
                nextEl: ".media-slider__button--next",
                prevEl: ".media-slider__button--prev",
            },
            pagination: {
                el: ".media-slider__pagination",
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                }
            }
        })
    }
})